<template>
  <div class="mt-12 max-w-lg mx-auto grid gap-5 lg:grid-cols-3 lg:max-w-none">
    <div v-for="job in jobs" :key="job.id" class="flex flex-col rounded-lg shadow-lg overflow-hidden border border-gray-200 bg-white transition-colors duration-200 ease-in-out hover:bg-gray-50">
      <div class="flex-1 p-6 flex flex-col justify-between">
        <div class="flex-1">
          <p class="text-xl font-semibold text-gray-900">
            {{ job.title }}
          </p>
          <p class="mt-3 text-base text-gray-500">
            {{ job.location }}
          </p>
        </div>
        <div class="mt-6">
          <a :href="job.link" target="_blank" class="inline-flex items-center px-4 py-2 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-awtmtn-blue hover:bg-awtmtn-dark-blue cursor-pointer">
            Apply Now
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import axios from 'axios'

interface Job {
  id: string
  title: string
  location: string
  link: string
}

const jobs = ref<Job[]>([])

const fetchAwetomatonJobs = async () => {
  try {
    const response = await axios.get('https://boards-api.greenhouse.io/v1/boards/awetomaton/jobs')
    jobs.value = response.data.jobs.map((job: any) => ({
      id: job.id,
      title: job.title,
      location: job.location.name,
      link: job.absolute_url
    }))
  } catch (error) {
    console.error('Error fetching job positions:', error)
    jobs.value = []
  }
}

onMounted(() => {
  fetchAwetomatonJobs()
})
</script>

<style scoped>
/* Remove unused styles */
</style>